import { faUser } from '@fortawesome/free-solid-svg-icons';
import { ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

import { Logout } from '»components/Auth';
import { menusSlice } from '»components/Menus/_menus.slice';
import {
  getActiveMenuItemSelector,
  getActiveNavigationMenuItemSelector,
  isMenuOpened,
} from '»components/Menus/menus.selectors';
import {
  DrawerMobileStyled,
  FontAwesomeIconMobileStyled,
  LeafListItemButtonMobileStyled,
  LeafListItemTextMobileStyled,
  ListItemIconMobileStyled,
  ListMobileStyled,
  RootListItemButtonMobileStyled,
} from '»components/Menus/Mobile';
import { useIsAbleToProceed } from '»utils/customHooks/useIsAbleToProceed';

const LogoutComponent = forwardRef(() => <Logout />);

LogoutComponent.displayName = 'LogoutComponent';

export const GenericMenuItemsMobile = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const activeNavigationMenuItem = useSelector(
    getActiveNavigationMenuItemSelector,
  );
  const isOpen = useSelector(isMenuOpened);

  const OPTION_ID = 'GENERIC';
  const LEAF_OPTION_ID1 = 'SETTINGS';

  const { isAbleToProceed } = useIsAbleToProceed();

  const handleClickLeafMenu = (event, menuItem) => {
    isAbleToProceed(event, () => {
      dispatch(
        menusSlice.actions.setActiveMenuItem({ activeMenuItem: menuItem }),
      );
      dispatch(
        menusSlice.actions.setActiveNavigationMenuItem({
          activeNavigationMenuItem: '',
        }),
      );
    });
  };

  const handleClickMenuRoot = (menuItem) => {
    if (activeNavigationMenuItem === menuItem) {
      dispatch(
        menusSlice.actions.setActiveNavigationMenuItem({
          activeNavigationMenuItem: '',
        }),
      );
    } else {
      dispatch(
        menusSlice.actions.setActiveNavigationMenuItem({
          activeNavigationMenuItem: menuItem,
        }),
      );
    }
  };

  return (
    <>
      <DrawerMobileStyled
        open={activeNavigationMenuItem.includes(OPTION_ID)}
        anchor="bottom"
        onClose={(_, reason) =>
          (reason === 'backdropClick' || reason === undefined) &&
          dispatch(
            menusSlice.actions.setActiveNavigationMenuItem({
              activeNavigationMenuItem: '',
            }),
          )
        }
      >
        <ListMobileStyled
          component="div"
          disablePadding
          opened={activeNavigationMenuItem.includes(OPTION_ID)}
          selected={activeMenuItem?.includes(OPTION_ID)}
        >
          <LeafListItemButtonMobileStyled
            onClick={(event) =>
              handleClickLeafMenu(event, `${OPTION_ID}:${LEAF_OPTION_ID1}`)
            }
            component={Link}
            to="/Settings"
            selected={activeMenuItem?.includes(
              `${OPTION_ID}:${LEAF_OPTION_ID1}`,
            )}
            id="btnMenuSettings"
          >
            <LeafListItemTextMobileStyled
              primary={<FormattedMessage id="TRLT_UI-SETTINGS" />}
              selected={activeMenuItem?.includes(
                `${OPTION_ID}:${LEAF_OPTION_ID1}`,
              )}
              isOpen={isOpen}
            />
          </LeafListItemButtonMobileStyled>

          <LeafListItemButtonMobileStyled component={LogoutComponent} />
        </ListMobileStyled>
      </DrawerMobileStyled>
      <RootListItemButtonMobileStyled
        onClick={() => handleClickMenuRoot(OPTION_ID)}
        selected={activeMenuItem?.includes(OPTION_ID)}
        opened={activeNavigationMenuItem.includes(OPTION_ID)}
        isSubMenuPopup={activeNavigationMenuItem !== ''}
        id="btnMenuSettings"
      >
        <ListItemIconMobileStyled>
          <FontAwesomeIconMobileStyled
            icon={faUser}
            selected={activeMenuItem?.includes(OPTION_ID)}
          />
        </ListItemIconMobileStyled>
        <ListItemText primary={<FormattedMessage id="TRLT_UI-USER" />} />
      </RootListItemButtonMobileStyled>
    </>
  );
};

GenericMenuItemsMobile.propTypes = {
  isOpen: PropTypes.bool,
  activeMenuItem: PropTypes.string,
  setActiveMenuItem: PropTypes.func,
  activeNavigationMenuItem: PropTypes.string,
  setActiveNavigationMenuItem: PropTypes.func,
};
